<div class="modal-display_outer" @click="onBorderClick">
  <div class="modal-display_inner">
    <slot></slot>
  </div>
</div>
